export default (theme) => {
  return `
  .mu-sub-header {
    color: ${theme.text.secondary};
  }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/SubHeader/theme.js